import $ from 'jquery';

// フォームの送信処理
$('#contact-form').on('submit', (e) => {
    // 通常のフォーム処理を停止
    e.preventDefault();

    const MAIL_API = 'https://uniform.style/app/';

    const sendButton = document.querySelector('.send-button');
    const contactName = $('.contact_name').val();
    const contactOrganization = $('.contact_organization').val();
    const contactMail = $('.contact_mail').val();
    const contactTel = $('.contact_tel').val();
    const contactDetail = $('.contact_detail').val();
    const contactType = $('input[name="contact_type"]:checked').val();
    const uniformType = () => {
        const arr = [];
        const target = document.querySelectorAll('.uniform_type');

        target.forEach(e => {
            if (e.checked) {
                arr.push(e.value);
            }
        });

        return arr;
    };
    const uniformDetail = $('.uniform_detail').val();
    const uniformFeature = () => {
        const arr = [];
        const target = document.querySelectorAll('.uniform_feature');

        target.forEach(e => {
            if (e.checked) {
                arr.push(e.value);
            }
        });

        return arr;
    };
    const others = () => {
        const arr = [];
        const target = document.querySelectorAll('.others');

        target.forEach(e => {
            if (e.checked) {
                arr.push(e.value);
            }
        });

        return arr;
    };
    const othersFiscal = $('.others_fiscal').val();
    const othersMaker = $('.others_maker').val();
    const purchasing = $('.purchasing').val();
    const permissionToPublish = () => {
        const target = document.querySelector('.permission_to_publish');

        if (target.checked) {
            return target.value;
        } else {
            return '掲載しても問題ない';
        }
    };

    // 送信ボタンを押したあとは操作不可にする
    sendButton.setAttribute('disabled', '');
    sendButton.innerHTML = '<div class="loader"></div>';

    $.ajax({
        type: 'post',
        url: MAIL_API,
        datatype: 'json',
        data: {
            contact_name: contactName,
            contact_organization: contactOrganization,
            contact_mail: contactMail,
            contact_tel: contactTel,
            contact_detail: contactDetail,
            contact_type: contactType,
            uniform_type: uniformType(),
            uniform_detail: uniformDetail,
            uniform_feature: uniformFeature(),
            others: others(),
            others_fiscal: othersFiscal,
            others_maker: othersMaker,
            purchasing: purchasing,
            permission_to_publish: permissionToPublish(),
        }
    })
        .done((data) => {
            setInterval(() => { sendButton.innerHTML = '送信が完了しました'; }, 1000);
        })
        .fail(() => {
            alert('送信に失敗しました。時間をおいて再度お試しください。');
        });
});